import 'vuetify/styles'
import colors from 'vuetify/lib/util/colors'
// Vuetify
import { createVuetify } from 'vuetify'
import { getStoredThemeMode, resolveThemeName } from '@/composables/useThemeMode'

export default createVuetify({
  theme: {
    defaultTheme: resolveThemeName(getStoredThemeMode()),
    themes: {
      light: {
        dark: false,
        colors: {
          primary: colors.red.darken1, // #E53935
          secondary: colors.red.lighten4, // #FFCDD2
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: colors.red.darken1, // #E53935
          secondary: colors.red.lighten4, // #FFCDD2
        }
      },
    },
  },
})